module.exports = __webpack_public_path__ + "static/media/2_no.ff7dce95.png";